var exports = {
  "kL": "xa15a2ab7--b2943e--container",
  "HM": "xa15a2ab7--b2943e--btn",
  "Kk": "xa15a2ab7--b2943e--icon",
  "UE": "xa15a2ab7--b2943e--arrow",
  "Te": "xa15a2ab7--b2943e--texts",
};

module.exports = exports;
